import React from "react";
import DocumentCard from "./DocumentCard";
import { Col, Row } from "react-bootstrap";
import PreloaderDocCard from "./PreloaderDocCard";

function GeneratedDocs({ documents, queryingDocs, refreshComponent }) {
  return (
    <div>
      {documents?.length > 0 &&
        documents.map(
          (document) =>
            document.isGenerated === true && (
              <Col key={document.id} lg={12} md={12} sm={12}>
                <DocumentCard
                  title={document.title}
                  userTitle={documents.userTitle}
                  date={document.createdAt.substr(0, 10)}
                  id={document.id}
                  content={document.content}
                  isGenerated={document.isGenerated}
                />
              </Col>
            )
        )}
      {queryingDocs && (
        <div>
          <Row>
            <PreloaderDocCard />
          </Row>
          <Row>
            <PreloaderDocCard />
          </Row>
          <Row>
            <PreloaderDocCard />
          </Row>
          <Row>
            <PreloaderDocCard />
          </Row>
          <Row>
            <PreloaderDocCard />
          </Row>
          <Row>
            <PreloaderDocCard />
          </Row>
        </div>
      )}
      {documents?.length === 0 && !queryingDocs ? (
        <h5 className="mt-5">You have not generated any docs yet</h5>
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default GeneratedDocs;
